import { CalculationColumn } from "../../types/column-types"
import { onAnyStandardCell } from "../../helpers/helpers"
import { renderCalcPos } from "../../helpers/helpers"

export const idCalculatuionPositionColumn: CalculationColumn = {
    dataIndex: 'id',
    title: '№',
    width: 40,
    onCell: onAnyStandardCell,
    render: renderCalcPos (r => r.id)
}